import { Col, Input, Row } from "antd";
import React from "react";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { BsArrowRight } from "react-icons/bs";

import "./Completed.css";
import { bankCompletedTransfers } from "../../../../data/accounting";
import { useNavigate } from "react-router-dom";

const CompletedTransfersRightBar = [

      RightBarMethod(
        " REPORTS",
        "t1",
        <i className="fa-solid fa-chart-column"></i>,
        [
          RightBarMethod("Bank Account Activity", "1", "", "", "/"),
          RightBarMethod("General Ledger", "2", "", "", "/"),
        ]
      ),

  ];

function Completed() {

  const navigate = useNavigate();

  return (
    <>
      <div className="completed">
        <PageHeading heading="Completed Transfers" />
        <Row className="input-container">
          <Col span={12}>
            <Input placeholder="Search by Bank Name and Property Name" />
          </Col>
        </Row>
        {/* {
          bankCompletedTransfers.map((item, index)=>{
            return(
              <Row align="middle" className="transfers-container" key={index} onClick={()=>navigate(`/accounting/bank_transfers_incomplete/completed/bank-transfer/${item.id}`)}>
          <Col span={5} className="span-container">
            <span><strong>{item.transferredFrom}</strong></span>
            <span>{item.transfers}</span>
          </Col>
          <Col span={1}>
          <BsArrowRight className="silver-text" size={20} />
          </Col>
          <Col span={6} className="span-container">
            <span><strong>{item.transferredTo}</strong></span>
            <span>{item.transfers}</span>
          </Col>
          <Col span={3} className="span-container">
          {
              item.transferredDate !== "" ? (<><span className="silver-text">Transfered</span><span>{item.transferredDate}</span></>) : null
            }
          </Col>
          <Col span={3} className="span-container">
            {
              item.createdDate !== "" ? (<><span className="silver-text">Created</span><span>{item.createdDate}</span></>) : null
            }
          </Col>
          <Col span={3} className="span-container">
            <span className="silver-text">Amount</span>
            <span>${item.amount}</span>
          </Col>
          <Col span={3}>
            {
              item.completed ? <span className="completed-span">Completed</span> : <span className="canceled-span">Canceled</span>
            }
          </Col>
        </Row>
            )
          })
        } */}
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={CompletedTransfersRightBar} />
      </div>
    </>
  );
}

export default Completed;